import { datas } from "../../locales/user-agreement/data";
import { useLocation } from 'react-router-dom';
import { resolveSupportedLang } from "../../utils/language";
function Scene({appName}) {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get('lang');
  const requested = resolveSupportedLang(query);
  const lang = datas.hasOwnProperty(requested) ? requested : "en_GB";
  const text = datas[lang] || datas.en_GB;
  
  return (
    <div style={{
      maxWidth: '1280px',
      margin: '0px auto',
      padding: 20,
      color: 'rgba(33, 33, 33, 1)',
      fontSize: '11px',
      fontWeight: 400,
      lineHight: 1.6667
    }}>
      {text.map((item, index) => {
        return <div key={index} style={{textAlign: index == 0 ? 'center' : 'left'}}>
          {
            item.replace(new RegExp("########", "gm"), appName)
          }
        <p></p></div>
      })}
    </div>
  );
}
export default Scene;
